(() => {
  const storageKey = 'marom:wishlist:v1';
  const drawer = document.getElementById('marom-wishlist-drawer');
  const itemsContainer = drawer?.querySelector('[data-marom-wishlist-items]');
  const emptyState = drawer?.querySelector('[data-marom-wishlist-empty]');

  if (!drawer || !itemsContainer || !emptyState) return;

  const readWishlist = () => {
    try {
      const raw = window.localStorage.getItem(storageKey);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.id) : [];
    } catch (_error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
  };

  const getProductData = (button) => ({
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
    compareAt: button.dataset.productCompareAt,
    variantId: button.dataset.variantId,
  });

  const createText = (className, text) => {
    const element = document.createElement('span');
    element.className = className;
    element.textContent = text || '';
    return element;
  };

  const updateButtons = (items) => {
    const ids = new Set(items.map((item) => String(item.id)));

    document.querySelectorAll('[data-marom-wishlist-toggle]').forEach((button) => {
      const selected = ids.has(String(button.dataset.productId));
      const title = button.dataset.productTitle || 'product';
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        `${selected ? 'Remove' : 'Add'} ${title} ${selected ? 'from' : 'to'} wishlist`
      );

      const label = button.querySelector('[data-marom-wishlist-label]');
      if (label) label.textContent = selected ? 'Remove from wishlist' : 'Add to wishlist';
    });

    document.querySelectorAll('[data-marom-wishlist-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
  };

  const renderWishlist = () => {
    const items = readWishlist();
    itemsContainer.replaceChildren();
    emptyState.hidden = items.length > 0;

    items.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'marom-wishlist-drawer__item';

      const image = document.createElement('img');
      image.loading = 'lazy';
      image.alt = item.title || '';
      image.src = item.image || '';

      const content = document.createElement('div');
      content.className = 'marom-wishlist-drawer__item-content';

      const title = document.createElement('a');
      title.className = 'marom-wishlist-drawer__item-title';
      title.href = item.url || '#';
      title.textContent = item.title || 'Product';

      const price = document.createElement('div');
      price.className = 'marom-wishlist-drawer__item-price';
      price.append(createText('', item.price || ''));
      if (item.compareAt) {
        const compareAt = document.createElement('s');
        compareAt.textContent = item.compareAt;
        price.append(compareAt);
      }

      const actions = document.createElement('div');
      actions.className = 'marom-wishlist-drawer__item-actions';

      const view = document.createElement('a');
      view.href = item.url || '#';
      view.textContent = 'View product';

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.dataset.maromWishlistRemove = item.id;
      remove.setAttribute('aria-label', `Remove ${item.title || 'product'} from wishlist`);

      actions.append(view, remove);
      content.append(title, price, actions);
      row.append(image, content);
      itemsContainer.append(row);
    });

    updateButtons(items);
  };

  const toggleItem = (button) => {
    const product = getProductData(button);
    if (!product.id) return;

    const items = readWishlist();
    const existingIndex = items.findIndex((item) => String(item.id) === String(product.id));

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.unshift(product);
    }

    writeWishlist(items);
    renderWishlist();
  };

  const openDrawer = () => {
    renderWishlist();
    if (typeof drawer.showModal === 'function') {
      drawer.showModal();
    } else {
      drawer.setAttribute('open', '');
    }
  };

  const closeDrawer = () => {
    if (typeof drawer.close === 'function' && drawer.open) {
      drawer.close();
    } else {
      drawer.removeAttribute('open');
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-marom-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(toggle);
      return;
    }

    if (event.target.closest('[data-marom-wishlist-open]')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-marom-wishlist-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const remove = event.target.closest('[data-marom-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      const items = readWishlist().filter((item) => String(item.id) !== String(remove.dataset.maromWishlistRemove));
      writeWishlist(items);
      renderWishlist();
    }
  });

  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) renderWishlist();
  });

  renderWishlist();
})();
